export const numberInputMiddlewares = (
  handler?: (e: any) => boolean | void,
  disableE = true,
) => (e: any) => {
  const inputValue = e?.target?.value || '';

  const length = {
    max: parseInt(e.target.max || ''),
    maxLength: parseInt(e.target.maxLength || ''),
  }
  if (length.max < 0) length.max = Infinity;
  if (length.maxLength < 0) length.maxLength = Infinity;


  if (
    disableE &&
    inputValue?.toLowerCase()?.match(/e/)
  ) {
    e.target.value = inputValue.replace('e', '');
    e.target.value = inputValue.replace('E', '');
    return;
  }

  const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
  const charStr = String.fromCharCode(charCode);
  if (!charStr.match(/^[0-9]+$/)) e.preventDefault();

  if (
    disableE &&
    (charCode === 69 || charCode === 101) &&
    inputValue.indexOf('e') === -1
  ) {
    e.preventDefault();
  }

  if (!isNaN(length?.max) && !isNaN(parseInt(inputValue)) && parseInt(inputValue) > length.max) e.target.value = length.max.toString();

  if (!isNaN(length?.maxLength) && inputValue?.length > length.maxLength) e.target.value = inputValue.slice(0, length.maxLength);
  if (inputValue?.length > 1 && inputValue.toString()[0] === '0') e.target.value = inputValue.slice(1);

  if (handler) {
    let result = handler(e) || true;
    if (!result && e?.preventDefault) e.preventDefault();
  }
}

export const inpNum = (e: any) => {
  e = e || window.event;
  const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
  const charStr = String.fromCharCode(charCode);
  if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
};